import { render, staticRenderFns } from "./Classic.vue?vue&type=template&id=052a1440"
import script from "./Classic.vue?vue&type=script&lang=js"
export * from "./Classic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports